/**
 * Whop Pay — always reads live Shopify /cart.js (not stale Liquid hidden fields).
 * Fixes "Panier invalide" when the cart drawer UI updates but the form HTML does not.
 */
(function () {
  if (window.__whopPaySubmitBound) return;
  window.__whopPaySubmitBound = true;

  var SESSION_URL = "https://pay.oran-boutique.com/checkout/session";

  function setBusy(btn, label, on, text) {
    if (btn) {
      btn.disabled = !!on;
      if (on) btn.setAttribute("aria-busy", "true");
      else btn.removeAttribute("aria-busy");
    }
    if (label) label.textContent = text;
  }

  function startCheckout(btn) {
    if (!btn || btn.disabled || btn.getAttribute("aria-busy") === "true") return;

    var label = btn.querySelector(".button-text");
    var original = label ? label.textContent : "Payer";
    setBusy(btn, label, true, "Chargement…");

    var controller = typeof AbortController !== "undefined" ? new AbortController() : null;
    var timer = controller
      ? setTimeout(function () {
          controller.abort();
        }, 20000)
      : null;

    fetch("/cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
      signal: controller ? controller.signal : undefined,
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Impossible de lire le panier");
        return res.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) {
          throw new Error("Votre panier est vide. Ajoutez un article puis réessayez.");
        }
        var lineItems = cart.items.map(function (item) {
          return {
            variantId: String(item.variant_id),
            title: item.product_title,
            quantity: item.quantity,
            price: (Number(item.final_price) / 100).toFixed(2),
          };
        });
        var amount = (Number(cart.total_price) / 100).toFixed(2);
        var currency =
          (window.Shopify && Shopify.currency && Shopify.currency.active) ||
          cart.currency ||
          "EUR";

        return fetch(SESSION_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            currency: currency,
            amount: amount,
            email: (window.Shopify && Shopify.customerEmail) || undefined,
            lineItems: lineItems,
          }),
          signal: controller ? controller.signal : undefined,
        }).then(function (res) {
          return res.text().then(function (text) {
            var data = null;
            try {
              data = text ? JSON.parse(text) : null;
            } catch (e) {
              throw new Error("Réponse invalide du serveur de paiement");
            }
            if (!res.ok) {
              throw new Error(
                (data && (data.message || data.error)) || "Checkout failed (" + res.status + ")"
              );
            }
            if (!data || !data.infoUrl) throw new Error("Missing checkout info URL");
            window.location.assign(data.infoUrl);
          });
        });
      })
      .catch(function (err) {
        console.error(err);
        var msg =
          err && err.name === "AbortError"
            ? "Délai dépassé. Vérifiez votre connexion et réessayez."
            : (err && err.message) || "Impossible de démarrer le paiement";
        window.alert(msg);
        setBusy(btn, label, false, original);
      })
      .finally(function () {
        if (timer) clearTimeout(timer);
      });
  }

  // Prefer button click (works even if theme hijacks form submit).
  document.addEventListener(
    "click",
    function (event) {
      var btn =
        event.target &&
        event.target.closest &&
        event.target.closest("#whop-checkout-form button[type='submit'], .whop-pay-button");
      if (!btn) return;
      var form = btn.closest("#whop-checkout-form") || btn.closest("form");
      if (form && form.id !== "whop-checkout-form" && !btn.classList.contains("whop-pay-button")) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }
      startCheckout(btn);
    },
    true
  );

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || form.id !== "whop-checkout-form") return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }
      var btn = form.querySelector('button[type="submit"]');
      startCheckout(btn);
    },
    true
  );
})();
